import controller from './checkout.controller'
import template from './checkout.html';
import './checkout.scss';

let module = angular.module('checkout', [
	'ionic'
])
.config(($stateProvider) => {
	"ngInject";

	$stateProvider
		.state('tab.checkout', {
			url: '/checkout',
			views: {
				'tab-checkout': {
					template: template,
					controller: controller,
					controllerAs: 'checkout',
				}
			}
		})
})
.name;

export default module;



// WEBPACK FOOTER //
// ./app/components/checkout/checkout.js